module.exports = __webpack_public_path__ + "static/media/9r-logo.90c4961e.png";